<template>
  <div :style="{height:mHeight}">
    <el-col :span="6"><div class="grid-content"></div></el-col>
    <el-col :span="12" style="background-color: white" :style="{height:mHeight}">
      <div style="width: 100%;height: 55%;border-bottom: 1px dashed #cfcfcf; ">
        <div style="width: 100%;height: 10%;"></div>
        <div style="width: 100%;height: 50%;">
          <div style="width: 60%;height: 100%;float:left;">
            <el-image style="width: 100%;height: 20%;" fit="contain" src="http://zgpic.xingfujijiu.cn/f1.png"></el-image>
            <div style="width: 100%;height: 40%;">
              <div style="width: 100%;height: 20%"></div>
              <div style="width: 100%;height: 80%;position: relative">
                <el-image style="width: 25%;height: 100%;position:absolute;left: 10px;" fit="contain" src="http://zgpic.xingfujijiu.cn/f2.png"></el-image>
                <div style="position:absolute;top: 2%;left: 30%;color: black" :style="{fontSize:minFontSize1}">防伪查询</div>
                <input :style="{height:input1H,fontSize:minFontSize2}" v-model="input1" placeholder="请输入防伪码" style="text-indent:5px;width: 60%;position:absolute;bottom: 5%;left: 30%;display: block"/>
              </div>
            </div>
            <div style="width: 100%;height: 40%;">
              <div style="width: 100%;height: 10%"></div>
              <div style="width: 100%;height: 80%;position: relative;">
                <div style="position:absolute;top: 5%;left: 2%;color: black" :style="{fontSize:minFontSize2}">验证码</div>
                <input :style="{height:input1H,fontSize:minFontSize2}" v-model="input2" placeholder="请输入验证码" style="text-indent:5px;width: 30%;position:absolute;bottom: 15%;left: 2%"/>
                <el-image  class="hand" @click="code1change()" :style="{height:input1H}" style="width: 30%;position:absolute;left: 38%;bottom: 15%;" fit="fill" :src="code1"></el-image>
                <el-image @click="check1()" class="hand" :style="{height:input1H}" style="width: 25%;position:absolute;left: 70%;bottom: 15%;" fit="scale-down" src="http://zgpic.xingfujijiu.cn/f6.png"></el-image>
              </div>
              <div style="width: 100%;height: 10%;"></div>
            </div>
          </div>

          <div style="width: 40%;height: 100%;float:right;">
            <el-image style="width: 100%;height: 100%;" fit="contain" src="http://zgpic.xingfujijiu.cn/f3.png"></el-image>
          </div>
        </div>
        <div style="width: 100%;height: 5%;text-align: left;text-indent: 1em;padding-top: 5px;border: 1px solid red;margin-bottom: 10px;" v-if="show1" :style="{fontSize:minFontSize3,color:color,borderColor:color}">{{show1T}}</div>
        <div style="width: 100%;height: 30%;background-color: green">
          <el-image style="width: 100%;height: 100%;" fit="cover" src="http://zgpic.xingfujijiu.cn/f4.png?2"></el-image>
        </div>
      </div>
      <div style="width: 100%;height: 45%">
        <div style="width: 100%;height: 5%;"></div>
        <div style="width: 100%;height: 70%;">
          <div style="width: 60%;height: 100%;float:left;">
            <el-image style="width: 100%;height: 30%;" fit="contain" src="http://zgpic.xingfujijiu.cn/f5.png"></el-image>
            <div style="width: 100%;height: 35%;">
              <div style="width: 100%;height: 100%;position: relative">
                <el-image style="width: 25%;height: 100%;position:absolute;left: 10px;" fit="contain" src="http://zgpic.xingfujijiu.cn/f2.png"></el-image>
                <div style="position:absolute;top: 2%;left: 30%;color: black" :style="{fontSize:minFontSize1}">防伪查询</div>
                <input :style="{height:input1H,fontSize:minFontSize2}" v-model="input21" placeholder="请输入防伪码" style="text-indent:5px;width: 60%;position:absolute;bottom: 5%;left: 30%;display: block"/>
              </div>
            </div>
            <div style="width: 100%;height: 35%;">
              <div style="width: 100%;height: 10%"></div>
              <div style="width: 100%;height: 90%;position: relative;">
                <div style="position:absolute;top: 10%;left: 2%;color: black" :style="{fontSize:minFontSize2}">验证码</div>
                <input :style="{height:input1H,fontSize:minFontSize2}" v-model="input22" placeholder="请输入验证码" style="text-indent:5px;width: 30%;position:absolute;bottom: 15%;left: 2%"/>
                <el-image  class="hand" @click="code2change()" :style="{height:input1H}" style="width: 30%;position:absolute;left: 38%;bottom: 15%;" fit="fill" :src="code2"></el-image>
                <el-image @click="check2()" class="hand" :style="{height:input1H}" style="width: 25%;position:absolute;left: 70%;bottom: 15%;" fit="scale-down" src="http://zgpic.xingfujijiu.cn/f6.png"></el-image>
              </div>
            </div>
          </div>
          <div style="width: 30%;height: 100%;float:right;">
            <el-image style="width: 100%;height: 100%;" fit="contain" src="http://zgpic.xingfujijiu.cn/f7.png"></el-image>
          </div>
        </div>
        <div style="width: 100%;height: 6%;text-align: left;text-indent: 1em;color: blue;padding-top: 10px" v-if="show2" :style="{fontSize:minFontSize3}">{{show2T}}</div>
        <div style="width: 100%;height: 2%;"></div>
        <div style="width: 100%;height: 10%;">
          <el-image style="width: 100%;height: 100%;" fit="cover" src="http://zgpic.xingfujijiu.cn/f8.png"></el-image>
        </div>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content"></div>
    </el-col>
  </div>
</template>

<script>
import PubSub from "pubsub-js";
import axios from "axios";

export default {
  name: "verify",
  methods:{
    check1(){
      if (!this.input1){
        this.$message({
          message: '请输入防伪码',
          type: 'warning'
        });
        return;
      }
      if (!this.input2){
        this.$message({
          message: '请输入验证码',
          type: 'warning'
        });
        return;
      }
      let that=this;
      axios.get('/proxy/verify.php',{
        params: {
          id: this.id1,
          bianhao: this.input1,
          code: this.input2,
        }
      }).then(function (response) {

        let info=response.data;
        if (info.code=='1'){
          that.id1=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
          that.code1="http://v.zgjt123.com/code.php?id="+that.id1;
          that.show1=true;
          that.show1T="尊敬的顾客您好,您购买的是中谷集团旗下正品产品，请放心食用";
          that.color="blue";
        }else if(info.code=='0'){
          that.show1=false;
          that.$message.error('验证码错误');
        }else if(info.code=='3'){
          that.id1=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
          that.code1="http://v.zgjt123.com/code.php?id="+that.id1;
          that.$message.error('验证码过期，已为您刷新验证码');
        }else{
          that.id1=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
          that.code1="http://v.zgjt123.com/code.php?id="+that.id1;
          that.show1=true;
          that.show1T="尊敬的顾客您好,该产品未查询到，谨防假冒";
          that.color="red";
        }
      }).catch(function (error) {
        console.log(error)
      })

    },
    check2(){
      if (!this.input21){
        this.$message({
          message: '请输入精油防伪码',
          type: 'warning'
        });
        return;
      }
      if (!this.input22){
        this.$message({
          message: '请输入精油验证码',
          type: 'warning'
        });
        return;
      }
      let that=this;
      axios.get('/proxy/verify.php',{
        params: {
          id: this.id2,
          bianhao: this.input21,
          code: this.input22,
        }
      }).then(function (response) {

        let info=response.data;
        if (info.code=='1'){
          that.id2=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
          that.code2="http://v.zgjt123.com/code.php?id="+that.id2;
          that.show2=true;
          that.show2T="尊敬的顾客您好,您购买的是中谷集团旗下正品产品，请放心食用";
          that.color="blue";
        }else if(info.code=='0'){
          that.show2=false;
          that.$message.error('验证码错误');
        }else if(info.code=='3'){
          that.id2=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
          that.code2="http://v.zgjt123.com/code.php?id="+that.id2;
          that.$message.error('验证码过期，已为您刷新验证码');
        }else{
          that.id2=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
          that.code2="http://v.zgjt123.com/code.php?id="+that.id2;
          that.show2=true;
          that.show2T="尊敬的顾客您好,该产品未查询到，谨防假冒";
          that.color="red";
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    code1change(){
      this.id1=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
      this.code1="http://v.zgjt123.com/code.php?id="+this.id1;
    },
    code2change(){
      this.id2=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
      this.code2="http://v.zgjt123.com/code.php?id="+this.id2;
    }
  },
  data(){
    return {
      mHeight:document.body.clientWidth*1380/1920+'px',
      input1:'',
      input2:'',
      show1:true,
      show1T:"",
      input21:'',
      input22:'',
      show2:true,
      show2T:"",
      minFontSize1:(document.body.clientWidth<850?850:document.body.clientWidth)/60+"px",
      minFontSize2:(document.body.clientWidth<850?850:document.body.clientWidth)/70+"px",
      minFontSize3:(document.body.clientWidth<850?850:document.body.clientWidth)/90+"px",
      input1H:(document.body.clientWidth<850?850:document.body.clientWidth)/45+"px",
      code1:'',
      code2:'',
      id1:'',
      id2:'',
      color:'blue'
    }
  },
  created() {
    PubSub.publish('changeIndex', this.$route);
    this.show1=false;
    this.show2=false;
  },
  mounted() {
    this.id1=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
    this.code1="http://v.zgjt123.com/code.php?id="+this.id1;
    this.id2=Math.round(Math.random()*10000)+new Date().getTime()+Math.round(Math.random()*10000);
    this.code2="http://v.zgjt123.com/code.php?id="+this.id2;

    setTimeout(function(){
      //手动触发窗口resize事件
      if(document.createEvent) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
      } else if(document.createEventObject) {
        window.fireEvent("onresize");
      }
    },1);

    window.addEventListener("resize", () => {
      this.mHeight=document.body.clientWidth*1380/1920+'px';
      this.minFontSize1=(document.body.clientWidth<850?850:document.body.clientWidth)/60+"px";
      this.minFontSize2=(document.body.clientWidth<850?850:document.body.clientWidth)/70+"px";
      this.minFontSize3=(document.body.clientWidth<850?850:document.body.clientWidth)/90+"px";
      this.input1H=(document.body.clientWidth<850?850:document.body.clientWidth)/45+"px";
    });

  },
}
</script>

<style lang="scss">


.zhaopintabs{
  .el-tabs__active-bar.is-top{
    background-image:none !important;
    height: 2px !important;
    background-color: #ff5e0e !important;
  }
  .el-tabs__nav-wrap::after{
    background-color: white !important;
  }
  .el-tabs__item.is-active{
    color: #ff5e0e !important;
  }
  .el-tabs__item.is-top:hover{
    color: #ff5e0e !important;
  }
  .el-tabs__item.is-top{
    height: 50px!important;
    color: black !important;
  }
  .el-tabs.el-tabs--top{
    margin-top: 50px!important;
  }
  .el-tabs__item {
    padding: 0px!important;
    line-height: 50px !important;
  }
  .el-tabs__nav-wrap.is-top{
    width: 60% !important;
  }
}
.pointer:hover{
  cursor: default;
}
.hand:hover{
  cursor: pointer;
}
</style>